// extracted by mini-css-extract-plugin
export default {"brcUserText":"UserNavbar_brcUserText__+Zbq7","brcUserProfileText":"UserNavbar_brcUserProfileText__ldPVr","brcMain":"UserNavbar_brcMain__kJ-Q9"};